import { Fragment, HTMLAttributes, memo } from 'react';

import { SliderTrackOverlay, SliderTrackStyled } from './HistogramOverlayTrack.styled';

function HistogramOverlayTrack(props: HTMLAttributes<unknown>) {
  const { children, style, ...other } = props;

  return (
    <Fragment>
      {style && <SliderTrackOverlay style={{ left: 0, width: style.left }} />}

      <SliderTrackStyled style={style} {...other} />

      {style && (
        <SliderTrackOverlay
          style={{
            left: `calc(${style.left} + ${style.width})`,
            width: `calc(100% - (${style.left} + ${style.width}))`,
          }}
        />
      )}
    </Fragment>
  );
}

export default memo(HistogramOverlayTrack);
